import { RouteConfig } from 'vue-router';

const data: RouteConfig = {
  path: '/data',
  component: () => import('../views/data/data.vue'),
  meta: {
    title: '数据开发中心'
  },
  children: [
    {
      path: '/data/datasource',
      meta: {
        title: '数据接入'
      },
      component: () => import('../views/data/pages/datasource/datasource.vue'),
      children: [
        {
          path: '/data/datasource/detail',
          meta: {
            title: '数据源详情'
          },
          component: () => import('../views/data/pages/datasource/datasource-detail.vue')
        },
        {
          path: '/data/datasource/add',
          meta: {
            title: '创建数据源'
          },
          component: () => import('../views/data/pages/datasource/datasource-form.vue')
        },
        {
          path: '/data/datasource/edit',
          meta: {
            title: '编辑数据源'
          },
          component: () => import('../views/data/pages/datasource/datasource-form.vue')
        },
        {
          path: '/data/datasource/tableconfig',
          meta: {
            title: '数据源表配置'
          },
          component: () => import('../views/data/pages/datasource/table-config.vue')
        },
      ]
    },
    {
      path: '/data/datacollect',
      meta: {
        title: '数据采集'
      },
      component: () => import('../views/data/pages/datacollect/datacollect.vue'),
      children: [
        {
          path: '/data/datacollect/detail',
          meta: {
            title: '采集任务详情'
          },
          component: () => import('../views/data/pages/datacollect/datacollect-detail.vue')
        },
        {
          path: '/data/datacollect/add',
          meta: {
            title: '创建采集任务'
          },
          component: () => import('../views/data/pages/datacollect/datacollect-form.vue')
        },
        {
          path: '/data/datacollect/edit',
          meta: {
            title: '编辑采集任务'
          },
          component: () => import('../views/data/pages/datacollect/datacollect-form.vue')
        }
      ]
    },
    {
      path: '/data/dataprocess',
      meta: {
        title: '数据加工'
      },
      component: () => import('../views/data/pages/dataprocess/dataprocess.vue'),
      children: [
        {
          path: '/data/dataprocess/flow/flinksql',
          meta: {
            title: 'FlinkSQL数据加工作业'
          },
          component: () => import('../views/data/pages/dataprocess/dataprocess-flow-flinksql.vue')
        },
        {
          path: '/data/dataprocess/flow/doris',
          meta: {
            title: 'Doris数据加工作业'
          },
          component: () => import('../views/data/pages/dataprocess/dataprocess-flow-doris.vue')
        },
        {
          path: '/data/dataprocess/flow/python',
          meta: {
            title: 'Python数据加工作业'
          },
          component: () => import('../views/data/pages/dataprocess/dataprocess-flow-python.vue')
        },
        {
          path: '/data/dataprocess/flow/shell',
          meta: {
            title: '脚本数据加工作业'
          },
          component: () => import('../views/data/pages/dataprocess/dataprocess-flow-shell.vue')
        },
        {
          path: '/data/dataprocess/flow/detail',
          meta: {
            title: '数据加工任务流程详情'
          },
          component: () => import('../views/data/pages/dataprocess/dataprocess-flow.vue')
        },
        {
          path: '/data/dataprocess/flow/edit',
          meta: {
            title: '数据加工任务流程'
          },
          component: () => import('../views/data/pages/dataprocess/dataprocess-flow.vue')
        },
        {
          path: '/data/dataprocess/flow/add',
          meta: {
            title: '数据加工任务流程'
          },
          component: () => import('../views/data/pages/dataprocess/dataprocess-flow.vue')
        }
      ]
    }
  ]
};

export default data;
